import React, { createContext, useContext, ReactNode } from 'react';
import { useMouseNavigation } from '../hooks/useMouseNavigation';

interface MouseNavigationContextType {
  disableMouseNavigation: () => void;
  enableMouseNavigation: () => void;
  getNavigationState: () => any;
}

const MouseNavigationContext = createContext<MouseNavigationContextType | null>(null);

interface MouseNavigationProviderProps {
  children: ReactNode;
}

export const MouseNavigationProvider: React.FC<MouseNavigationProviderProps> = ({ children }) => {
  const mouseNav = useMouseNavigation();

  return (
    <MouseNavigationContext.Provider value={mouseNav}>
      {children}
    </MouseNavigationContext.Provider>
  );
};

export const useMouseNavigationContext = () => {
  const context = useContext(MouseNavigationContext);
  if (!context) {
    throw new Error('useMouseNavigationContext must be used within a MouseNavigationProvider');
  }
  return context;
};
